module.exports = __webpack_public_path__ + "img/crop_original-white-24dp.dffa36c8.svg";